import styled from "styled-components";
import { Flex } from "rebass/styled-components";
import { ErrorBoundary } from "react-error-boundary";

import { ClipOfTheDay } from "./ClipOfTheDay";
import { CompetitionsBanner } from "./CompetitionsBanner";
import { ContentFeed } from "./ContentFeed";
import { SuggestedFeed } from "./SuggestedFeed";
import { HomepageWrapper, CONTENT_MAX_WIDTH } from "./styledComponents";
import { HomepageViewModel } from "./ViewModel";
import { ESupportedGames } from "../../@types";
import { GAME_TO_ICON_MAP } from "../../Components/GameSelector";
import { UserBadge } from "MVVM/Components/UserBadge";
import { AdUnit } from "../../Components/Ads";

const Homepage = () => {
  const {
    contentFeeds,
    contentFeedsLoading,
    prosFeed,
    prosFeedLoading,
    todayInCs,
    todayInCsLoading,
    allstarUser,
  } = HomepageViewModel();
  const isLoggedIn = allstarUser.loggedIn;
  const csIcon = GAME_TO_ICON_MAP[ESupportedGames.CS2];

  const allstarFeed = (
    <ContentFeed
      title="Clipped with !allstar"
      titleTo="/!allstar"
      data={contentFeeds?.allstar?.nodes}
      loading={contentFeedsLoading}
      vanillaThumbnail
    />
  );

  return (
    <HomepageWrapper>
      <HomepageContainer>
        <ClipOfTheDay />
        <CappedContent>
          {!isLoggedIn && allstarFeed}
          <ErrorBoundary fallback={<></>}>
            <CompetitionsBanner />
          </ErrorBoundary>
          <AdContainer>
            <AdUnit
              slotId="homepage-billboard"
              adUnitType="billboard"
              allowProgrammatic
              collapseIfEmpty
            />
          </AdContainer>
          {isLoggedIn ? (
            <ContentFeed
              title="For You"
              data={contentFeeds?.forYou}
              loading={contentFeedsLoading}
              suggestionReason="Suggested for you"
              vanillaThumbnail
            />
          ) : prosFeed || prosFeedLoading ? (
            <ContentFeed
              title="From the Pros"
              data={prosFeed}
              loading={prosFeedLoading}
              isProsFeed={true}
              icon={
                <UserBadge
                  userGroup="PRO_PLAYER"
                  style={{ marginRight: "8px" }}
                />
              }
            />
          ) : (
            <ContentFeed
              title="For You"
              data={contentFeeds?.forYou?.nodes}
              loading={contentFeedsLoading}
              vanillaThumbnail
            />
          )}

          {(todayInCsLoading || Boolean(todayInCs?.length)) && (
            <ContentFeed
              title="Today in Counter-Strike"
              data={todayInCs}
              loading={todayInCsLoading}
              isProsFeed={true}
              icon={csIcon}
            />
          )}

          <ContentFeed
            title="Counter-Strike 2"
            data={contentFeeds?.cs2?.nodes}
            loading={contentFeedsLoading}
            icon={csIcon}
          />

          <ContentFeed
            title="Recent Montages"
            data={contentFeeds?.montages?.nodes}
            loading={contentFeedsLoading}
            isMontageFeed={true}
          />

          {isLoggedIn && allstarFeed}

          <ErrorBoundary fallback={<></>}>
            <SuggestedFeed />
          </ErrorBoundary>
        </CappedContent>
      </HomepageContainer>
    </HomepageWrapper>
  );
};

const HomepageContainer = styled(Flex)`
  flex-direction: column;
  gap: 32px;
  padding-bottom: 80px;
  width: 100%;
`;

// Caps + centers everything below the hero so it lines up with the hero
// content, while the hero background (ClipOfTheDay) bleeds wider behind it.
const CappedContent = styled(Flex)`
  align-self: center;
  flex-direction: column;
  gap: 32px;
  margin: 0 auto;
  max-width: ${CONTENT_MAX_WIDTH};
  width: 100%;
`;

const AdContainer = styled(Flex)`
  justify-content: center;
  width: 100%;
  @media (min-width: 1500px) {
    display: none;
  }
`;

export default Homepage;
